import React from 'react';
import UserDataTable from './UserDataTable';
import './UserManager.css';

const UserManager: React.FC = () => {
  return (
    <div className="user-manager">
      <UserDataTable />
    </div>
  );
};

export default UserManager;